export default {
  fleetSupplierBookings: [],
  fleetSupplierBooking: undefined,
};
